import { render, staticRenderFns } from "./ImportMultiCamChooseAnnotation.vue?vue&type=template&id=018de4aa"
import script from "./ImportMultiCamChooseAnnotation.vue?vue&type=script&lang=ts"
export * from "./ImportMultiCamChooseAnnotation.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports